import { useEffect, useRef } from "react";
import appstore from "../assets/images/app-store.svg"
import playstore from "../assets/images/google-play.svg"

const Home = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Bubble class
    class Bubble {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + Math.random() * 100;
        this.radius = Math.random() * 4 + 1;
        this.speedY = Math.random() * 1 + 0.5;
        this.speedX = Math.random() * 0.5 - 0.25;
        this.opacity = Math.random() * 0.5 + 0.1;
      }

      update() {
        this.y -= this.speedY;
        this.x += this.speedX;

        if (this.y + this.radius < 0) {
          this.y = canvas.height + this.radius;
          this.x = Math.random() * canvas.width;
        }
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${this.opacity})`;
        ctx.fill();
        ctx.closePath();
      }
    }

    // Create bubbles
    const bubbles = [];
    const bubbleCount = 50;

    for (let i = 0; i < bubbleCount; i++) {
      bubbles.push(new Bubble());
    }

    // Animation loop
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      bubbles.forEach(bubble => {
        bubble.update();
        bubble.draw();
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return (
    <>
      <div className="hero-container" id="home">
        <canvas ref={canvasRef} className="bubble-canvas"></canvas>
        <div className="container">
          <div className="row justify-content-center home_section">
            <div className="col-lg-9">
              <div className="black-box-wrapper text-white">
                <div className="row justify-content-center">
                  <div className="col-lg-9">
                    <div className="f-40 text-center fw-bold">
                      <h2 className="">Lutlo</h2>
                    </div>
                  </div>
                </div>
                <div className="f-18 mt-3 mb-3 hero-banner-content">
                <p>We create stunning cross-platform mobile apps using modern Flutter technology. Whether you're starting with a fresh concept or scaling an existing product, our team ensures seamless execution, beautiful UI, and powerful performance.</p>
                </div>
                
                <div className="pt-md-1 app-download d-flex justify-content-center gap-2">
                  <a
                    href="https://apps.apple.com/sb/developer/di-labs/id1221305504"  rel="noopener noreferrer">
                    <img src={appstore} alt="App Store" className="img-fluid" width="190" height="60" />
                  </a>
                  <a href="https://play.google.com/store/apps/dev?id=6717661217853138886"  rel="noopener noreferrer">
                    <img src={playstore} alt="Google Play" className="img-fluid" width="190" height="60" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;

